import {z} from 'zod'

const EmailTemplatesPaginationSchema = z.object({
  pageNumber: z.number().optional(),
  pageSize: z.number().optional(),
  totalElements: z.number().optional(),
  totalPages: z.number().optional(),
})

const EmailTemplateDetailsSchema = z.object({
  template_id: z.string(),
  template_name: z.string().optional(),
  category: z.string().optional(),
  subject: z.string(),
  body: z.string(),
  user: z.string(),
})

export const EmailTemplateListItemSchema = z.object({
  template_id: z.string(),
  template_name: z.string().max(100).optional(),
  category: z.string().optional(),
})

export const GetEmailTemplatesRequestSchema = z.object({
  pageNumber: z.number().optional(),
  pageSize: z.number().optional(),
  sortBy: z.string().optional(),
})

export const GetEmailTemplatesResponseSchema = z.object({
  content: z.array(EmailTemplateListItemSchema),
  pagination: EmailTemplatesPaginationSchema.optional(),
  success: z.boolean().optional(),
  errorMessage: z.string().nullish(),
})

export const GetEmailTemplateByIdRequestSchema = z.void()
export const GetEmailTemplateByIdResponseSchema = z.object({
  content: z.array(EmailTemplateDetailsSchema),
  success: z.boolean().optional(),
  errorMessage: z.string().nullish(),
})

export type EmailTemplateListItem = z.infer<typeof EmailTemplateListItemSchema>
export type GetEmailTemplatesRequest = z.infer<typeof GetEmailTemplatesRequestSchema>
export type GetEmailTemplatesResponse = z.infer<typeof GetEmailTemplatesResponseSchema>
export type GetEmailTemplateByIdRequest = z.infer<typeof GetEmailTemplateByIdRequestSchema>
export type GetEmailTemplateByIdResponse = z.infer<typeof GetEmailTemplateByIdResponseSchema>
